import recordingStore from './consumer';

export default {
  namespaced: true,
  modules: {
    consumer: recordingStore
  }
}
